import { 
  collection, 
  query, 
  where, 
  getDocs 
} from 'firebase/firestore';
import { db } from '../config/firebase';

// Check if an item is available for the given date range
export const checkItemAvailability = async (itemId, itemType, startDate, endDate) => {
  try {
    // Query all bookings that include this item
    const bookingsRef = collection(db, 'bookings');
    const q = query(
      bookingsRef,
      where('status', 'in', ['confirmed', 'completed'])
    );
    
    const querySnapshot = await getDocs(q);
    
    // Check each booking for date conflicts
    for (const doc of querySnapshot.docs) {
      const booking = doc.data();
      
      // Check if this booking contains the item we're checking
      if (booking.items) {
        for (const item of booking.items) {
          if (item.id === itemId && item.type === itemType) {
            // Found the item in a booking, now check date overlap
            const bookingStart = new Date(item.startDate);
            const bookingEnd = new Date(item.endDate);
            const requestStart = new Date(startDate);
            const requestEnd = new Date(endDate);
            
            // Check if dates overlap
            if (requestStart <= bookingEnd && requestEnd >= bookingStart) {
              // Dates overlap - item is NOT available
              return {
                available: false,
                conflictingBooking: {
                  bookingId: doc.id,
                  startDate: item.startDate,
                  endDate: item.endDate,
                  customerName: booking.customerName
                }
              };
            }
          }
        }
      }
    }
    
    // No conflicts found - item IS available
    return { available: true };
    
  } catch (error) {
    // If permission denied or no bookings exist, assume available
    if (error.code === 'permission-denied' || error.message.includes('permission')) {
      console.log('Bookings collection not accessible - assuming item is available');
      return { available: true };
    }
    console.error('Error checking availability:', error);
    // Default to available on error to not block checkout
    return { available: true };
  }
};

// Check availability for multiple items
export const checkCartAvailability = async (cartItems) => {
  const unavailableItems = [];
  
  for (const item of cartItems) {
    if (item.dates && item.dates.start && item.dates.end) {
      const result = await checkItemAvailability(
        item.id,
        item.type,
        item.dates.start,
        item.dates.end
      );
      
      if (!result.available) {
        unavailableItems.push({
          ...item,
          conflict: result.conflictingBooking
        });
      }
    }
  }
  
  return {
    allAvailable: unavailableItems.length === 0,
    unavailableItems
  };
};

// Get all bookings for a specific item (for calendar view)
export const getItemBookings = async (itemId, itemType) => {
  try {
    const bookingsRef = collection(db, 'bookings');
    const q = query(
      bookingsRef,
      where('status', 'in', ['confirmed', 'completed'])
    );
    
    const querySnapshot = await getDocs(q);
    const itemBookings = [];
    
    querySnapshot.forEach((doc) => {
      const booking = doc.data();
      if (booking.items) {
        booking.items.forEach((item) => {
          if (item.id === itemId && item.type === itemType) {
            itemBookings.push({
              bookingId: doc.id,
              startDate: item.startDate,
              endDate: item.endDate,
              customerName: booking.customerName
            });
          }
        });
      }
    });
    
    return { success: true, bookings: itemBookings };

  } catch (error) {
    // If permission denied, return empty bookings
    if (error.code === 'permission-denied' || error.message.includes('permission')) {
      return { success: true, bookings: [] };
    }
    return { success: false, error: error.message };
  }
};